import { useDispatch, useSelector } from 'react-redux'
import { useEffect } from 'react'

import style from '@src/pages/Chips/Chips.module.scss'
import { AppDispatch } from '@src/store/store'
import { selectUserChips } from '@src/store/ducks/user/selectors'
import { getChips } from '@src/store/ducks/user/thunks'

export const Chips = () => {
  const dispatch = useDispatch<AppDispatch>()
  const myChips = useSelector(selectUserChips)

  useEffect(() => {
    dispatch(getChips())
  }, [dispatch])

  return (
    <div className={style.chips}>
      <div className={style.title}>
        Накопленные электронные фишки
      </div>
      <div className={style.chipsBlock}>
        <img
          src="/frontend/images/chips.png"
          className={style.image}
          alt="chips"
        />
        {myChips.electronicChips}
      </div>
    </div>
  )
}
